import {
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideSeoService } from '@geekeno/ngx-website/services';
import { authInterceptor } from '@geekeno/ngx-website/interceptors';

import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideClientHydration(withEventReplay()),
    provideSeoService({
      baseURL: environment.baseUrl,
      autoUpdateCanonicalURL: true,
      locale: 'en_IN',
      twitterSite: '@geekeno',
      defaultSiteImage: '/geekeno-og-image.png',
      siteName: 'Geekeno',
      titleSeparator: ' | ',
      warnIfMissingOnRoute: true,
    }),
  ],
};
